import {useContext} from "react";
import {MobXProviderContext} from "mobx-react";
import {IOutlineStore} from "../stores/OutlineStore";

export default function useOutlineStore(): IOutlineStore {
	return useContext(MobXProviderContext).outlineStore;
}
